import React from 'react';
import { useTranslation } from 'react-i18next';
import ShareIcon from '@mui/icons-material/Share';
import InfoIcon from '@mui/icons-material/Info';
import HomeIcon from '@mui/icons-material/Home';
import GroupIcon from '@mui/icons-material/Group';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import Groups3Icon from '@mui/icons-material/Groups3';
import { useTheme } from '@mui/material';
import { di } from '../state/inversify.config';
import { Pages } from '../state/queryParams/pageQueries.slice';
import { checkIfUserHasAdminRole } from '../pages/user/user.helpers';
import { AuthService } from '../state/helperServices/auth/auth.service';
import { Layout } from '../components/layout/layout.smart';

export function OrgLayout(): JSX.Element {
  const authService = di.get<AuthService>(AuthService);
  const loggedInUser = authService.useLoggedInUserSelector();
  const { t } = useTranslation();
  const theme = useTheme();
  const drawerNavigationItems = [
    {
      text: t('HOME'),
      icon: <HomeIcon sx={{ fill: theme.palette.text.primary }} />,
      link: '.',
    },
    {
      link: 'teams',
      text: t('TEAM_PAGE'),
      icon: <Diversity3Icon sx={{ fill: theme.palette.text.primary }} />,
      withDivider: true,
    },
    {
      link: `${Pages.conneqt}`,
      text: t('CONNEQT'),
      icon: <ShareIcon sx={{ fill: theme.palette.text.primary }} />,
      withDivider: true,
    },
    {
      link: 'about-us',
      text: t('ABOUT_CONNEQT'),
      icon: <InfoIcon sx={{ fill: theme.palette.text.primary }} />,
    },
  ];

  if (checkIfUserHasAdminRole(loggedInUser)) {
    drawerNavigationItems.splice(1, 0, {
      link: 'user',
      text: t('USERS'),
      icon: <Groups3Icon sx={{ fill: theme.palette.text.primary }} />,
    });
    drawerNavigationItems.splice(2, 0, {
      link: 'players',
      text: t('PLAYERS_PAGE'),
      icon: <GroupIcon sx={{ fill: theme.palette.text.primary }} />,
    });
  }

  return <Layout drawerNavigationItems={drawerNavigationItems} />;
}
